import React, { useMemo } from "react";
import { Badge } from "@fluentui/react-components";
import Stack from "./Stack";
import { getAmenitieImage } from "../common/utilities/utilities";
import { useTranslation } from "react-i18next";



const DEFAULTS_AMENITIES = 3;

function Amenities(props) {
  const {
    amenities = [],
    showAll = false,
    setShowAll = () => { }
  } = props;

  const { t } = useTranslation();

  const onToggleShowAll = event => {
    event.stopPropagation()
    setShowAll(prev => !prev)
  }

  const othersAmenitiesCount = useMemo(() =>amenities.length - DEFAULTS_AMENITIES, [amenities.length])
  
  return (
    <Stack direction="row" gap="8px" flexWrap="wrap">
      {amenities.slice(0, showAll ? amenities.length : DEFAULTS_AMENITIES).map((amenity) =>
        <Badge
          key={amenity.id}
          shape="rounded"
          color="subtle"
          size="large"
          appearance="tint"
        >
          {getAmenitieImage(amenity, t)}
        </Badge>
      )}


      {
        othersAmenitiesCount > 0 &&
        <Badge
          style={{ cursor: 'pointer' }}
          shape="rounded"
          color="subtle"
          size="large"
          appearance="tint"
          onClick={onToggleShowAll}
        >
          {showAll ? `-${othersAmenitiesCount}` : `+${othersAmenitiesCount}`}
        </Badge>}
    </Stack>
  )
}

export default Amenities;
